import React from 'react';

interface DestinationImageProps
	{
	mediaUrl?: string;
	mediaAlt?: string;
	index: number;
	rotationDegrees?: number;
	translateY?: string;
	stacked?: boolean;
	}

// Alternates the photo's tilt per tab, like scattered polaroids -- first tab
// positive, then alternating. `rotationDegrees` is the magnitude (block
// attribute "Image rotation"); sign alternates here based on index.
// `translateY` positions the image within the shared &__image-track when
// `stacked` (the frontend's scroll-driven image stack). Editor usage omits
// both and just fills its track normally.
export const DestinationImage = ({ mediaUrl, mediaAlt, index, rotationDegrees = 11.39, translateY = '0%', stacked = false }: DestinationImageProps) =>
	{
	if (!mediaUrl)
		{
		return null;
		}

	const rotation = index % 2 === 0 ? rotationDegrees : -rotationDegrees;
	const className = 'wp-block-ocean-destinations__image-wrapper' + (stacked ? ' is-stacked' : '');

	// The tilt goes out twice: as the frame's own transform, and as a custom
	// property the photo inside reads to cancel it (destinations.scss) so it
	// stays upright under what is now a tilted mask. Signed, unlike the
	// block-level --destinations-image-rotation, because the sign alternates
	// per tab right here.
	const style = {
		transform: `translateY(${translateY}) rotate(${rotation}deg)`,
		'--destinations-image-tilt': `${rotation}deg`,
		} as React.CSSProperties;

	return (
		<div className={className} style={style}>
			<img className="wp-block-ocean-destinations__image" src={mediaUrl} alt={mediaAlt || ''} />
		</div>
		);
	};
